import { __assign, __extends, __makeTemplateObject, __rest } from "tslib";
import { Layer } from 'grommet';
import merge from 'lodash/merge';
import * as React from 'react';
import styled, { createGlobalStyle, withTheme } from 'styled-components';
import { px } from '../../utils';
import { Box } from '../Box';
import { Button } from '../Button';
import { Flex } from '../Flex';
import { Heading } from '../Heading';
import { Txt } from '../Txt';
var bodyNoOverflowClass = "rendition-modal-open";
var GlobalStyle = createGlobalStyle(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\t.", " {\n\t\toverflow: hidden;\n\t}\n"], ["\n\t.", " {\n\t\toverflow: hidden;\n\t}\n"])), bodyNoOverflowClass);
var DEFAULT_MODAL_WIDTH = 700;
var ModalSizer = styled(Box)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n\toverflow-y: auto;\n"], ["\n\toverflow-y: auto;\n"])));
var HeadingDescription = styled(Txt)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n\tfont-weight: normal;\n"], ["\n\tfont-weight: normal;\n"])));
var ModalButton = function (props) {
    return 'href' in props && props.href ? (React.createElement(Button, __assign({ as: "a" }, props))) : (React.createElement(Button, __assign({}, props)));
};
var BaseModal = (function (_super) {
    __extends(BaseModal, _super);
    function BaseModal(props) {
        var _this = _super.call(this, props) || this;
        _this.ownIndex = 0;
        _this.handleKeyDown = function (e) {
            var _a;
            if (BaseModal.mountedCount !== _this.ownIndex) {
                return;
            }
            if (!e.defaultPrevented && e.which === 13) {
                e.preventDefault();
                e.stopPropagation();
                if ((_a = _this.props.primaryButtonProps) === null || _a === void 0 ? void 0 : _a.disabled) {
                    return;
                }
                if (e.which === 13) {
                    _this.props.done();
                }
            }
        };
        _this.stopPropagation = function (e) {
            return e.stopPropagation();
        };
        _this.popModal = function () {
            if (BaseModal.mountedCount !== _this.ownIndex) {
                return;
            }
            (_this.props.cancel || _this.props.done)();
        };
        return _this;
    }
    BaseModal.prototype.componentDidMount = function () {
        if (!BaseModal.mountedCount) {
            document.body.classList.add(bodyNoOverflowClass);
        }
        window.addEventListener('keydown', this.handleKeyDown);
        BaseModal.mountedCount++;
        this.ownIndex = BaseModal.mountedCount;
    };
    BaseModal.prototype.componentWillUnmount = function () {
        BaseModal.mountedCount--;
        if (!BaseModal.mountedCount) {
            document.body.classList.remove(bodyNoOverflowClass);
        }
        window.removeEventListener('keydown', this.handleKeyDown);
    };
    BaseModal.prototype.render = function () {
        var _a, _b, _c;
        var _d = this.props, width = _d.width, theme = _d.theme, props = __rest(_d, ["width", "theme"]);
        var cancelButtonProps = Object.assign({ ml: 3 }, props.cancelButtonProps);
        var secondaryButtonProps = Object.assign({
            primary: true,
            outline: true,
            ml: 3,
        }, props.secondaryButtonProps);
        var shouldChangePrimaryButtonOrder = ((_b = (_a = props.primaryButtonProps) === null || _a === void 0 ? void 0 : _a.danger) !== null && _b !== void 0 ? _b : (_c = props.primaryButtonProps) === null || _c === void 0 ? void 0 : _c.warning) === true;
        var primaryButtonProps = merge(__assign({ primary: true, ml: 3 }, (shouldChangePrimaryButtonOrder && {
            style: { order: -1 },
        })), props.primaryButtonProps);
        return (React.createElement(Layer, { onEsc: this.popModal, onClickOutside: this.popModal, responsive: false, position: props.position || 'center', margin: "small", animate: false, style: {
                marginTop: props.position === 'top' ? theme.header.height : undefined,
            } },
            React.createElement(GlobalStyle, null),
            React.createElement(ModalSizer, { width: width || DEFAULT_MODAL_WIDTH, maxWidth: "100%", onClick: this.stopPropagation, style: props.style, id: props.id, className: props.className },
                React.createElement(Box, { p: [px(theme.space[3]), '40px 50px 30px'] },
                    props.titleElement ? (React.createElement(Heading.h3, { mb: 4 }, props.titleElement)) : (!!props.title && (React.createElement(Heading.h3, { mb: 4 },
                        props.title,
                        !!props.titleDetails && (React.createElement(HeadingDescription, { color: "text.light", fontSize: 2 }, props.titleDetails))))),
                    props.children,
                    React.createElement(Flex, { mt: 5, alignItems: "center", justifyContent: "flex-end" },
                        props.cancel && (React.createElement(ModalButton, __assign({}, cancelButtonProps, { onClick: props.cancel }), (cancelButtonProps && cancelButtonProps.children) ||
                            'Cancel')),
                        props.secondaryButtonProps && (React.createElement(ModalButton, __assign({}, secondaryButtonProps))),
                        React.createElement(ModalButton, __assign({}, primaryButtonProps, { onClick: props.done }), props.action || 'OK'))))));
    };
    BaseModal.mountedCount = 0;
    return BaseModal;
}(React.Component));
export var Modal = withTheme(BaseModal);
var templateObject_1, templateObject_2, templateObject_3;
